export default function KoobSidebarBadge({ count }) {
  if (!count || count <= 0) return null;

  const display = count > 99 ? '99+' : count;

  return (
    <span className="inline-flex items-center justify-center min-w-[20px] h-5 px-1.5 text-xs font-medium text-k-h bg-k-orange rounded-full">
      {display}
    </span>
  );
}
